<template>
  <ul class="simple-list-container">
    <li v-for="(product, index) in products" :key="index" class="product">
      <div
        class="thumb"
        :style="{
          backgroundImage: 'url(' + imageUrl(product.previewImage) + ')'
        }"
      ></div>
      <div class="title">
        {{ product.name }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['products'],
  methods: {
    imageUrl(id) {
      return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${id}/66`
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-list-container {
  padding: 25px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.4) 0 20px 60px -2px;
  border-radius: 5px;
  max-height: 240px;
  overflow-y: auto;
}
.product {
  display: flex;
  margin-bottom: 7px;

  &:last-child {
    margin-bottom: 0;
  }
}
.thumb {
  width: 33px;
  height: 33px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-right: 7px;
  flex-shrink: 0;
  flex-grow: 0;
  //border-radius: 70px;
  border: 1px solid #efefef;
}

.title {
  flex-grow: 1;
  background-color: #f4f4f4;
  border-radius: 20px;
  height: 34px;
  line-height: 33px;
  font-weight: 500;
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
